import React from "react";
import { makeStyles } from "@mui/styles";
import { Button as Btn } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  margin: {
    marginTop: "2px",
    textTransform: "capitalize",
    fontSize: "12px",
    color: "#FFFFFF",
    backgroundColor: "#069038",
    padding: "5px 12px 4px 12px",
    fontStyle: "normal",
    lineHeight: "21px",
    letterSpacing: "0%",
    textAlign: "center",
    borderRadius: "4px",
    minWidth: "143.75px",
    height: "38px",
    opacity: 1,
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: "#069038",
      boxShadow: "none !important",
    },
    "&:active": {
      boxShadow: "none !important",
    },
    "&:focus": {
      boxShadow: "none !important",
    },

    [theme.breakpoints.up("md")]: {
      padding: "5px 16px 4px 16px",
      fontSize: "13px",
      marginTop: "5px",
    },
  },
}));
function FormButton(props) {
  const classes = useStyles(props);
  const {
    leftIcon,
    rightIcon,
    onClick,
    title = "",
    variant = "contained",
    isDisable,
  } = props;

  return (
    <Btn
      variant={variant}
      className={classes.margin}
      disableElevation
      disableRipple
      style={{
        color: isDisable ? "" : props.style?.color || "#FFFFFF",
        ...props.style,
      }}
      onClick={onClick}
    >
      {leftIcon && leftIcon}
      {title}
      {rightIcon && rightIcon}
    </Btn>
  );
}

export default FormButton;
